module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Open_Sans/OpenSans-Regular.woff2
// module id = 3482
// module chunks = 0